import { Card, Button, Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';

const LocationInfoBox = ({listIds, books, locationInfo, setSelectedBook, selectedBook}) => {  
  return (
      <div>
        <Card bg={'light'} text={'dark'} style={{ width: '18rem' }} className="mb-2">
          <Card.Header>Book Information</Card.Header>
          {!locationInfo ?
            <Card.Body>
                Please select the book from the map to view its information.
            </Card.Body> :
            <Card.Body>
              Book Name: {locationInfo.name} <br /> 
              Author: {locationInfo.author} <br />
              Condition: {locationInfo.condition} <br />
              Notes: {locationInfo.notes} <br />
              Exam Materials: {locationInfo.exam} <br />
              <Dropdown.Divider/>
              Provider:{locationInfo.provider}  <br />
              College: {locationInfo.college} <br /> 
              <br />
              {selectedBook?.indexOf(locationInfo) == -1 && !listIds.includes(locationInfo._id)  ? 
              <Button onClick = {() => {setSelectedBook([...selectedBook, locationInfo])}} variant="outline-primary">
                Add Email
            </Button>
          : 
            <OverlayTrigger key={locationInfo._id} placement={'right'} overlay={
              <Tooltip id={`tooltip-${'right'}`}>
                You can only send one email for any book.
              </Tooltip>
            }>
              <span>
                <Button onClick = {() => {setSelectedBook([...selectedBook, locationInfo])}} variant="outline-primary" disabled>
                  Add Email
                </Button>
              </span>
            </OverlayTrigger>
          }
          </Card.Body>  
          }
        </Card>
      </div>
    )
}

export default LocationInfoBox
